export default "__VITE_ASSET__pjJuQnPQ__"